import React from 'react';
import { Server } from '../../server/server';
import { AppConfig } from '../AppConfig';
import AlertModal from '../modals/AlertModal';
import MessageModal from '../modals/MessageModal';
import FriendPanel from '../elements/FriendPanel';
import PageEnvelope from '../elements/PageEnvelope';
import './SitePage.css'
import { Navigate } from 'react-router-dom';

interface FriendsPageState {
  slug: string;
  alert: string;
  message: string;
  loading: boolean;
}

class FriendsPage extends React.Component<{}, FriendsPageState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      slug: '',
      alert: '',
      message: '',
      loading: false
    };

    this.onSlugChange = this.onSlugChange.bind(this);
    this.onSlugKeyDown = this.onSlugKeyDown.bind(this);
    this.onFriendUpdated = this.onFriendUpdated.bind(this);
  }

  componentDidMount() {
    Server.user.addEventListener('friend-updated', this.onFriendUpdated);
    this.loadFriendProfiles();
  }

  componentWillUnmount() {
    Server.user.removeEventListener('friend-updated', this.onFriendUpdated);
  }

  onSlugChange(e: React.FormEvent<HTMLInputElement>): void {
    this.setState({slug: e.currentTarget.value});
  };

  onSlugKeyDown(e:any): void {
    if (e.key === 'Enter') 
      this.onInvite();
  };

  onFriendUpdated(data: any) {
    this.forceUpdate();
  }

  async onInvite() {
    if (!this.state.slug.trim()) {
      this.setState({alert: 'Slug invalid.'});
      return;
    } 

    this.setState({message: 'Sending invite...'});

    setTimeout(async () => {
      let slug = this.state.slug;
      if(slug.substring(0, 1) == '@')
        slug = slug.substring(1);
  
      let response = await Server.user.inviteFriendBySlug(slug);

      if (response.success) {
        await Server.public.loadProfileFromSlug(slug);
        this.setState({message: '', slug: ''});
      }
      else
        this.setState({alert: response.message, message: ''});
    }, 500);
  }

  async loadFriends() {
    let friendRefreshTime = window.sessionStorage.getItem(`FriendRefresh`);
    if(friendRefreshTime) {
      let refreshTime = parseInt(friendRefreshTime);
      let now = new Date().getTime();
      if(now - refreshTime < 1000 * 60) 
        return;
    }

    await Server.public.sleep(250);
    await Server.user.getFriends();

    window.sessionStorage.setItem(`FriendRefresh`, new Date().getTime().toString());
  }

  async loadFriendProfiles() {
    this.setState({ loading: true });
    await this.loadFriends();
    const friends = Server.user.getFriendsFromCache();
    const friendIds = friends.map(friend => friend.id);
    if (friendIds.length > 0) 
      await Server.public.loadProfiles(friendIds);
    this.setState({ loading: false });
  }

  renderFriends() {
    if (this.state.loading) {
      return (
        <div className="site-page-panel">
          Loading...
        </div>
      );
    }

    let friends = Server.user.getFriendsFromCache();

    if(friends.length == 0) {
      return( 
        <div className="site-page-notification-panel">
          Ask your friends in real life for their {AppConfig.title} handle (eg. @mrburns) and enter it above.
          You can also find the handle of any user on their public profile.
        </div>        
      )
    }

    let sortedFriends = [];
    for(let i = 0; i < friends.length; i++) {
      let friendId = friends[i].id;
      let profile = Server.public.getProfile(friendId);
      let presence = Server.user.getFriendPresence(friendId);
      let friend:any = {...profile, ...friends[i], presence};
      sortedFriends.push(friend);
    }

    sortedFriends.sort((a, b)=>{
      if(a.state == 'invited' && b.state != 'invited')
        return 1;
      else if(a.state != 'invited' && b.state == 'invited')
        return -1;

      if(a.state == 'accepted' && b.state != 'accepted')
        return 1;
      else if(a.state != 'accepted' && b.state == 'accepted')
        return -1;

      if(a.state == 'pending' && b.state != 'pending')
        return 1;
      else if(a.state != 'pending' && b.state == 'pending')
        return -1;

      if((a.presence && a.presence.online) && (!b.presence || !b.presence.online))
        return 1;
      else if((!a.presence || !a.presence.online) && (b.presence && b.presence.online))
        return -1;
        
      if(a.name > b.name)
        return -1;
      else if(a.name < b.name)
        return 1;

      return 0;
    })

    let divs = [];
    for(let i = sortedFriends.length-1; i >= 0; i--) 
      divs.push(<FriendPanel key={i} metadata={sortedFriends[i]} onUpdate={this.onFriendUpdated} />);

    return divs;
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          <div className="site-page-column">

            <div className="site-page-panel">
              <div className="site-page-row">
                @<input
                style={{width: '100%'}}
                  placeholder="Enter handle of user to invite"
                  value={this.state.slug}
                  onChange={this.onSlugChange}
                  onKeyDown={this.onSlugKeyDown}>
                </input>
                <button onClick={() => this.onInvite()}>Invite</button>
              </div>
            </div>

            <div className="site-page-column">
              {this.renderFriends()}
            </div>
          </div>
        </PageEnvelope>

        <MessageModal message={this.state.message} />
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default FriendsPage;